<template>
  <div class="survey_dashboard_container">
    <Statistic group-name="ih"></Statistic>
    <div >
      <div class="survey_dashboard-main">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div style="padding-bottom: 10px">
                <p style="font-size: 12px">Эх сурвалж: Нийгмийн халамжийн үйлчилгээний мэдээллийн сан 2022 оны байдлаар.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <iframe
                src="https://analytic.edu-track.gov.mn/superset/dashboard/3/?standalone=true&native_filters=%28NATIVE_FILTER--kxZEe7i8%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER--kxZEe7i8%2CownState%3A%28%29%29%2CNATIVE_FILTER-8ST8GoShi%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-8ST8GoShi%2CownState%3A%28%29%29%2CNATIVE_FILTER-8oXGxJN8I%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-8oXGxJN8I%2CownState%3A%28%29%29%2CNATIVE_FILTER-G6aW_bwjH%3A%28__cache%3A%28label%3A%2712%27%2CvalidateMessage%3A%21f%2CvalidateStatus%3A%21f%2Cvalue%3A%21%28%2712%27%29%29%2CextraFormData%3A%28filters%3A%21%28%28col%3A%3Csar_string%3E%2Cop%3AIN%2Cval%3A%21%28%2712%27%29%29%29%29%2CfilterState%3A%28label%3A%2712%27%2CvalidateMessage%3A%21f%2CvalidateStatus%3A%21f%2Cvalue%3A%21%28%2712%27%29%29%2Cid%3ANATIVE_FILTER-G6aW_bwjH%2CownState%3A%28%29%29%2CNATIVE_FILTER-HrWRSY5VK%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-HrWRSY5VK%2CownState%3A%28%29%29%2CNATIVE_FILTER-UmrmjIGVu%3A%28__cache%3A%28label%3A%272021%27%2CvalidateMessage%3A%21f%2CvalidateStatus%3A%21f%2Cvalue%3A%21%282021%29%29%2CextraFormData%3A%28filters%3A%21%28%28col%3Aon_jil%2Cop%3AIN%2Cval%3A%21%282021%29%29%29%29%2CfilterState%3A%28label%3A%272021%27%2CvalidateMessage%3A%21f%2CvalidateStatus%3A%21f%2Cvalue%3A%21%282021%29%29%2Cid%3ANATIVE_FILTER-UmrmjIGVu%2CownState%3A%28%29%29%2CNATIVE_FILTER-XaBFzw7oM%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-XaBFzw7oM%2CownState%3A%28%29%29%2CNATIVE_FILTER-iQ9UA8A0V%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-iQ9UA8A0V%2CownState%3A%28%29%29%2CNATIVE_FILTER-jmaoWrvqZ%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-jmaoWrvqZ%2CownState%3A%28%29%29%2CNATIVE_FILTER-uEG2wB1LZ%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-uEG2wB1LZ%2CownState%3A%28%29%29%2CNATIVE_FILTER-yDOVNUazq%3A%28extraFormData%3A%28%29%2CfilterState%3A%28%29%2Cid%3ANATIVE_FILTER-yDOVNUazq%2CownState%3A%28%29%29%29"
                frameborder="0"
                style="border: none; width: 100%; height: 100vh"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <about></about>
  </div>
</template>

<script>
const Statistic = () => import(/* webpackChunkName: "statistic" */ './statistic')
const about = () => import(/* webpackChunkName: "p_about" */ '../section/p_about')
export default {
  name: "UG_halamj",
  components: {
    "Statistic": Statistic,
    "about": about,
  }
}
</script>

<style scoped>

</style>
